module.exports = COS;